import { Link } from 'react-router-dom';
import { MapPin, CheckCircle } from 'lucide-react';
import { StarRating } from './StarRating';

export function ProfissionalCard({ profissional }) {
  const {
    nome, slug, cidade, estado, bairro, avatarUrl,
    categorias = [], servicos = [],
    mediaAvaliacoes = 0, totalAvaliacoes = 0,
    verificado, premium
  } = profissional;

  const tags = categorias.length > 0 ? categorias : servicos.map(s => s.nome);
  const initial = nome?.[0]?.toUpperCase() || '?';

  return (
    <Link
      to={`/profissional/${slug}`}
      className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 block group"
      data-testid="profissional-card"
    >
      <div className="flex items-start gap-4">
        <div className="relative flex-shrink-0">
          {avatarUrl ? (
            <img src={avatarUrl} alt={nome} className="w-16 h-16 rounded-2xl object-cover" />
          ) : (
            <div className="w-16 h-16 bg-[#E1F5EE] rounded-2xl flex items-center justify-center">
              <span className="text-[#1D9E75] font-bold text-2xl">{initial}</span>
            </div>
          )}
          {verificado && (
            <div className="absolute -bottom-1 -right-1 bg-[#1D9E75] rounded-full p-0.5 shadow">
              <CheckCircle size={13} className="text-white" />
            </div>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1.5">
            <h3 className="font-semibold text-gray-900 group-hover:text-[#1D9E75] transition-colors truncate text-sm">
              {nome}
            </h3>
            {premium && (
              <span className="text-xs bg-amber-50 text-amber-700 border border-amber-100 px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0">
                Premium
              </span>
            )}
          </div>

          {/* Categorias — máx 2 tags compactas */}
          {tags.length > 0 && (
            <div className="flex items-center gap-1.5 mb-2 flex-wrap">
              {tags.slice(0, 2).map((t, i) => (
                <span key={i} className="text-xs text-[#0F6E56] bg-[#E1F5EE] px-2 py-0.5 rounded-full whitespace-nowrap">
                  {t}
                </span>
              ))}
              {tags.length > 2 && (
                <span className="text-xs text-gray-400">+{tags.length - 2}</span>
              )}
            </div>
          )}

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1 text-gray-400">
              <MapPin size={11} />
              <span className="text-xs truncate">
                {bairro ? `${bairro} · ${cidade}` : `${cidade}/${estado}`}
              </span>
            </div>
            {totalAvaliacoes > 0 && (
              <div className="flex items-center gap-1">
                <StarRating rating={mediaAvaliacoes} size={11} />
                <span className="text-xs text-gray-400">({totalAvaliacoes})</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
